import React from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {MenuLink} from '../utils/types';

export const paymentMethods: MenuLink[] = [
  {icon: 'card', slug: 'payment-methods/credit-cards', title: <Trans>Credit cards</Trans>},
  {icon: 'bizum', slug: 'payment-methods/bizum', title: <Trans>Bizum</Trans>},
  {icon: 'bizum', to: 'https://monei.com/blog/stripe-bizum-payments/', title: 'Bizum + Stripe'},
  {icon: 'paypal', slug: 'payment-methods/paypal', title: <Trans>PayPal</Trans>},
  {icon: 'google-pay', slug: 'payment-methods/google-pay', title: <Trans>Google Pay</Trans>},
  {icon: 'apple-pay', slug: 'payment-methods/apple-pay', title: <Trans>Apple Pay</Trans>},
  {icon: 'click2pay', slug: 'payment-methods/click-to-pay', title: 'Click to Pay'},
  {icon: 'mobile', slug: 'features/tap-to-pay-iphone', title: 'Tap to Pay (iPhone)'},
  {icon: 'mobile', slug: 'features/tap-to-phone', title: 'Tap to Phone (Android)'},
  {icon: 'sepa', slug: 'payment-methods/sepa-request-to-pay', title: 'SEPA Request-to-Pay'},
  {
    icon: 'sepa',
    slug: 'payment-methods/sepa-direct-debit',
    title: <Trans>SEPA Direct Debit</Trans>,
    soon: <Trans>BETA</Trans>
  },
  {icon: 'multibanco', slug: 'payment-methods/multibanco', title: <Trans>Multibanco</Trans>},
  {icon: 'mb-way', slug: 'payment-methods/mb-way', title: 'MB Way'},
  {icon: 'bancontact', slug: 'payment-methods/bancontact', title: <Trans>Bancontact</Trans>}
];

export const ecommercePlatforms: MenuLink[] = [
  {icon: 'shopify', slug: 'shopify-payment-gateway', title: 'Shopify'},
  {icon: 'woocommerce', slug: 'woocommerce-payment-gateway', title: 'WooCommerce'},
  {icon: 'prestashop', slug: 'prestashop-payment-gateway', title: 'PrestaShop'},
  {icon: 'wix', slug: 'wix-payment-gateway', title: 'Wix'},
  {icon: 'magento', slug: 'magento-payment-gateway', title: 'Adobe Commerce (Magento 2)'},
  {
    icon: 'salesforce',
    to: 'https://docs.monei.com/docs/e-commerce/salesforce/',
    title: 'Salesforce'
  },
  {icon: 'spreedly', to: 'https://docs.spreedly.com/payment-gateways/monei/', title: 'Spreedly'},
  {icon: 'commercetools', title: 'commercetools'},
  {
    icon: 'medusa',
    to: 'https://docs.monei.com/e-commerce/medusa/',
    toByLanguage: {es: 'https://docs.monei.com/es/e-commerce/medusa/'},
    title: 'Medusa'
  }
];
